import { Token } from '@coast/schemas';
import React, { useContext } from 'react';
import { PersonComponent } from '@shared/scenes/workflows/config';
import { WorkflowTemplateDataContext } from '@shared/scenes/workflows/context/WorkflowTemplateDataProvider';
import { useWorkflowDispatch } from '@shared/scenes/workflows/context/context';
import { DefaultPersonSelection } from './DefaultPersonSelection';
import { useDefaultPersonSelectionHooks } from './hooks/DefaultPersonSelectionHooks';

interface Props {
  component: PersonComponent;
}

export function DefaultPersonSelectionContainer({ component }: Props) {
  const { users } = useContext(WorkflowTemplateDataContext);
  const dispatch = useWorkflowDispatch();

  function newUserIdDefaults(userId: number): number[] {
    if (component.default?.userIds?.includes(userId)) {
      return component.default.userIds.filter(item => item !== userId);
    }
    return [userId].concat(component.default?.userIds ?? []);
  }

  function onSelectPerson(userId: number) {
    const userIds = newUserIdDefaults(userId);
    dispatch({
      type: 'updateComponent',
      args: {
        ...component,
        default: { token: null, userIds: userIds },
      },
    });
  }

  function onMeSelected() {
    dispatch({
      type: 'updateComponent',
      args: {
        ...component,
        default: {
          token: component.default?.token === Token.ME ? undefined : Token.ME,
          userIds: [],
        },
      } as PersonComponent,
    });
  }

  const hooks = useDefaultPersonSelectionHooks(
    users,
    {
      token: component.default?.token ?? null,
      userIds: component.default?.userIds ?? null,
    },
    onSelectPerson,
    onMeSelected,
  );

  return <DefaultPersonSelection hooks={hooks} />;
}
